module.exports = __webpack_public_path__ + "img/top.4f8df983.png";